define('app/sf/merge/sf-merge-filter',[],function () {
	return {
		filter: function mergeFilter(input, target) {
			var inputIsArray,
				targetIsArray;
			if (!angular.isObject(input)) {
				return input;
			}
			else {
				inputIsArray = angular.isArray(input);
				if (input === target || !angular.isObject(target)) {
					return angular.extend(inputIsArray ? [] : {}, input);
				}
				else {
					targetIsArray = angular.isArray(target);
					if (inputIsArray && targetIsArray) {
						return input.concat(target);
					}
					else {
						return angular.extend(inputIsArray ? [] : {}, input, target);
					}
				}
			}
		},
		comparator: function mergeComparator(actual, expected) {
			if (!angular.isObject(actual) || !angular.isObject(expected)) {
				return actual === expected || (isNaN(actual) && isNaN(expected));
			}
			var actualKeys = Object.keys(actual),
				expectedKeys = Object.keys(expected),
				allKeys = actualKeys.filter(function (k) {
					return expectedKeys.indexOf(k) <= 0;
				}).concat(expectedKeys),
				k, i;

			for (i = 0; i < allKeys.length; i++) {
				k = allKeys[i];
				if (!Object.hasOwnProperty.call(actual, k) ||
					!Object.hasOwnProperty.call(expected, k) ||
					(actual[k] !== expected[k] && !isNaN(actual[k] && !isNaN(expected[k])))) {
					return false;
				}
			}
			return true;
		}
	};
});
